import styled from "styled-components";
import { FunctionComponent } from "react";

interface SpacerProps {
  x?: number;
  y?: number;
}

export const Spacer: FunctionComponent<SpacerProps> = (props) => (
  <StyledDiv {...props}></StyledDiv>
);

const StyledDiv = styled.div<SpacerProps>`
  width: ${({ x }) => (x ? x.toString() : "0")}rem;
  height: ${({ y }) => (y ? y.toString() : "0")}rem;
  flex-shrink: 0;
`;
